import { useEffect, useReducer } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import effects from 'app/effects/effects'
import * as R from 'ramda'
import endpointConfig from 'app/effects/apis/endpointConfig'
import { getToken } from 'app/services/userService/userStorage'
import { mapDataConversationList } from 'app/main/messages/conversations/useConversation'
import moment from 'moment'
import {
  setIsInConversationRoom,
  updateConversationList,
} from 'app/store/actions/conversation.actions'
import { useUserProfile } from 'commons/useUserProfile'
import { useDefaultLanguage } from 'commons/useDefaultLanguage'
import { makeConnection, SocketEvent } from './socket'

export const MessageStatus = {
  SENDING: 'sending',
  SENT: 'sent',
  READ: 'read',
}

const LOAD_MORE_PAGE_SIZE = 10
const SEND_MESSAGE_TIMEOUT = 5000
const ROLE_ADMIN = 'admin'

const initChatRoom = {
  data: [],
  meta: {
    last_key: null,
    per_page: 100,
    total: 16,
  },
}

const initialState = {
  isConnected: false,
  chatRoomData: initChatRoom,
  isReadMessage: false,
  isChatLoading: false,
  socket: null,
  error: undefined,
  fetchedAt: null,
  openingHistoryId: null,
  lastKey: '',
  isLoadingMore: true,
  loadMoreAt: null,
  sendingMessage: {},
}

export const ActionType = {
  CONNECT_SOCKET: 'CONNECT_SOCKET',
  DISCONNECT_SOCKET: 'DISCONNECT_SOCKET',
  SET_SOCKET: 'SET_SOCKET',
  FETCH_INIT: 'FETCH_INIT',
  FETCH_SUCCESS: 'FETCH_SUCCESS',
  FETCH_FAILURE: 'FETCH_FAILURE',
  FETCH_INIT_SOCKET: 'FETCH_INIT_SOCKET',
  CLEAR_DATA: 'CLEAR_DATA',
  REFETCH: 'REFETCH',
  OPEN_CHAT_ROOM: 'OPEN_CHAT_ROOM',
  LOAD_MORE_SUCCESS: 'LOAD_MORE_SUCCESS',
  LOAD_MORE_FAILURE: 'LOAD_MORE_FAILURE',
  SET_LOADING_MORE: 'SET_LOADING_MORE',
  SEND_MESSAGE: 'SEND_MESSAGE',
  SEND_MESSAGE_SUCCESS: 'SEND_MESSAGE_SUCCESS',
  USER_READ_MESSAGE: 'USER_READ_MESSAGE',
  CHECK_MESSAGE_TIMEOUT: 'CHECK_MESSAGE_TIMEOUT',
  RESEND_MESSAGE: 'RESEND_MESSAGE',
  DELETE_MESSAGE: 'DELETE_MESSAGE',
  TRANSLATE_MESSAGE: 'TRANSLATE_MESSAGE',
  ALLOW_TRANSLATION: 'ALLOW_TRANSLATION',
  TRANSLATING_MESSAGE: 'TRANSLATING_MESSAGE',
  TRALSATE_SUCCESS: 'TRALSATE_SUCCESS',
  TRALSATE_FAILURE: 'TRALSATE_FAILURE',
  SHOW_ORIGINAL_MESSAGE: 'SHOW_ORIGINAL_MESSAGE',
}

const reducer = (state, action) => {
  switch (action.type) {
    case ActionType.CONNECT_SOCKET:
      return {
        ...state,
        isConnecnoted: true,
      }
    case ActionType.DISCONNECT_SOCKET:
      if (state.socket) {
        state.socket.disconnect()
      }
      return {
        ...state,
        isConnected: false,
      }
    case ActionType.SET_SOCKET:
      return {
        ...state,
        socket: action.payload,
      }
    case ActionType.FETCH_INIT:
      return {
        ...state,
        chatRoomData: initChatRoom,
        isChatLoading: true,
        error: undefined,
        fetchedAt: null,
      }
    case ActionType.FETCH_INIT_SOCKET:
      return {
        ...state,
        error: undefined,
      }
    case ActionType.FETCH_SUCCESS:
      return {
        ...state,
        chatRoomData: action.payload,
        isChatLoading: false,
        error: undefined,
        lastKey: action.payload.meta.last_key,
        sendingMessage: R.filter(R.propEq('isDraft', true))(
          state.sendingMessage,
        ),
      }
    case ActionType.FETCH_FAILURE:
      return {
        ...state,
        chatRoomData: initChatRoom,
        isChatLoading: false,
        error: action.payload,
      }
    case ActionType.CLEAR_DATA:
      return {
        ...state,
        chatRoomData: initChatRoom,
      }
    case ActionType.REFETCH:
      return {
        ...state,
        chatRoomData: initChatRoom,
        isChatLoading: false,
        error: undefined,
        fetchedAt: moment(),
      }
    case ActionType.OPEN_CHAT_ROOM:
      return {
        ...state,
        openingHistoryId: action.payload,
      }
    case ActionType.SET_LOADING_MORE:
      if (state && state.isLoadingMore === true && state.lastKey) {
        return { ...state, isLoadingMore: false, loadMoreAt: moment() }
      }
      return state
    case ActionType.LOAD_MORE_SUCCESS:
      return {
        ...state,
        chatRoomData: action.payload.chatRoomData,
        lastKey: action.payload.lastKey,
        isLoadingMore: true,
      }
    case ActionType.SEND_MESSAGE:
      let sendMessageArr = { ...state.sendingMessage }
      sendMessageArr[action.payload.tempUuid] = action.payload.msg
      return {
        ...state,
        sendingMessage: sendMessageArr,
      }
    case ActionType.SEND_MESSAGE_SUCCESS:
      let sendingArr = state.sendingMessage
      if (!sendingArr[action.payload.tempUuid]) {
        return state
      }
      sendingArr[action.payload.tempUuid].isDraft = false
      return { ...state, sendingMessage: sendingArr }
    case ActionType.USER_READ_MESSAGE:
      let crData = state.chatRoomData
      crData.data = R.map((obj) => {
        return { ...obj, is_read: true }
      }, state.chatRoomData.data)
      return { ...state, chatRoomData: crData }
    case ActionType.CHECK_MESSAGE_TIMEOUT:
      let updatedData = state.sendingMessage
      if (!updatedData[action.payload.tempUuid]) {
        return state
      }
      updatedData[action.payload.tempUuid].is_fail = true
      let clearBuffer = state.socket
      clearBuffer.sendBuffer = []
      return {
        ...state,
        sendingMessage: updatedData,
        socket: clearBuffer,
      }
    case ActionType.RESEND_MESSAGE:
      let lens = R.lensPath([action.payload.tempUuid, 'is_fail'])
      return {
        ...state,
        sendingMessage: R.set(lens, false, state.sendingMessage),
      }
    case ActionType.DELETE_MESSAGE:
      return {
        ...state,
        sendingMessage: R.dissoc(action.payload.tempUuid, state.sendingMessage),
      }
    case ActionType.TRANSLATE_MESSAGE:
      return {
        ...state,
      }
    case ActionType.ALLOW_TRANSLATION:
      var { uuid, languageCode, isAllowed } = action.payload
      var stateRoomData = state.chatRoomData
      stateRoomData.data = R.map((obj) => {
        if (obj.uuid === uuid) {
          obj.languageCode = languageCode
          obj.allowTranslation = isAllowed
          return obj
        }
        return obj
      }, state.chatRoomData.data)
      return {
        ...state,
        chatRoomData: stateRoomData,
      }
    case ActionType.TRANSLATING_MESSAGE:
      // eslint-disable-next-line no-redeclare
      var stateRoomData = state.chatRoomData
      stateRoomData.data = R.map(
        (obj) =>
          obj.uuid === action.payload.uuid
            ? R.assoc('isTranslating', true, obj)
            : obj,
        state.chatRoomData.data,
      )
      return {
        ...state,
        chatRoomData: stateRoomData,
      }
    case ActionType.TRALSATE_SUCCESS:
      // eslint-disable-next-line no-redeclare
      var stateRoomData = state.chatRoomData
      stateRoomData.data = R.map((obj) => {
        if (obj.uuid === action.payload.uuid) {
          obj.isTranslating = false
          obj.translatedMessage = action.payload.translatedMessage
          obj.showOriginalMessage = false
          return obj
        }
        return obj
      })(state.chatRoomData.data)
      return {
        ...state,
        chatRoomData: stateRoomData,
      }
    case ActionType.TRALSATE_FAILURE:
      // eslint-disable-next-line no-redeclare
      var stateRoomData = state.chatRoomData
      stateRoomData.data = R.map((obj) => {
        if (obj.uuid === action.payload.uuid) {
          obj.isTranslating = false
          obj.isTranslatingFailed = true
          return obj
        }
        return obj
      })(state.chatRoomData.data)
      return {
        ...state,
        chatRoomData: stateRoomData,
      }
    case ActionType.SHOW_ORIGINAL_MESSAGE:
      // eslint-disable-next-line no-redeclare
      var stateRoomData = state.chatRoomData
      stateRoomData.data = R.map((obj) => {
        if (obj.uuid === action.payload.uuid) {
          obj.showOriginalMessage = action.payload.isShow
          return obj
        }
        return obj
      })(state.chatRoomData.data)
      return {
        ...state,
        chatRoomData: stateRoomData,
      }
    default:
      throw new Error('Not supported action')
  }
}

export const useConversationSocket = (selectedConversation) => {
  const [
    {
      isConnected,
      chatRoomData,
      isChatLoading,
      socket,
      error,
      fetchedAt,
      lastKey,
      isLoadingMore,
      loadMoreAt,
      sendingMessage,
    },
    dispatch,
  ] = useReducer(reducer, initialState)

  const userData = useUserProfile()

  const getSelfSenderData = () => {
    return {
      avatar: userData.avatar,
      avatar_characters: userData.avatarCharacters,
      country_code: userData.avatar,
      email: userData.email,
      first_name: userData.firstName,
      id: userData.id,
      last_name: userData.lastName,
      phone_number: userData.phoneNumber,
      status: 1,
    }
  }

  const { conversationListData, historyIdSelected } = useSelector(
    ({ conversation }) => conversation,
  )
  const storeDispatcher = useDispatch()
  const defaultLanguge = useDefaultLanguage()
  const token = getToken()

  useEffect(() => {
    dispatch({ type: ActionType.FETCH_INIT })
    refresh()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultLanguge])

  useEffect(() => {
    if (token) {
      const socketInstance = makeConnection(
        endpointConfig.socketUrl(),
        token.accessToken,
      )
      dispatch({
        type: ActionType.SET_SOCKET,
        payload: socketInstance,
      })
    }
    return () => {
      dispatch({
        type: ActionType.DISCONNECT_SOCKET,
      })
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (socket) {
      //socket.off('connect');
      socket.on('connect', () => {
        socket.sendBuffer = []
      })

      socket.off('disconnect')
      socket.on('disconnect', () => {
        socket.sendBuffer = []
      })
    }
  }, [socket])

  useEffect(() => {
    if (R.isNil(selectedConversation)) {
      return
    }
    effects.apis
      .getConversationHistory(
        token.accessToken,
        selectedConversation.historyId,
        LOAD_MORE_PAGE_SIZE,
        lastKey,
      )
      .then((respData) => {
        var modifiedRes = modifiedResData(respData)
        let prependData = {
          ...chatRoomData,
          data: modifiedRes.data.concat(chatRoomData.data),
          meta: modifiedRes.meta,
        }
        dispatch({
          type: ActionType.LOAD_MORE_SUCCESS,
          payload: {
            chatRoomData: prependData,
            lastKey: modifiedRes.meta.last_key,
          },
        })
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadMoreAt])

  const loadMoreMessage = () => {
    dispatch({
      type: ActionType.SET_LOADING_MORE,
    })
  }

  const handleRecordUpdates = (command, recordId, placeId = false) => {
    if (!socket || !socket.connected) {
      const socketInstance = makeConnection(
        endpointConfig.socketUrl(),
        token.accessToken,
      )
      socketInstance.on('connect', () => {
        if (placeId) {
          socketInstance.emit(command, recordId, placeId)
        } else {
          socketInstance.emit(command, recordId)
        }
      })
      dispatch({
        type: ActionType.SET_SOCKET,
        payload: socketInstance,
      })
    } else {
      if (placeId) {
        socket.emit(command, recordId, placeId)
      } else {
        socket.emit(command, recordId)
      }
    }
  }

  const handleSendMessage = (
    history_id,
    place_id,
    subscriber_id,
    message,
    cb,
  ) => {
    let tempUuid = moment().format('x')

    dispatch({
      type: ActionType.SEND_MESSAGE,
      payload: {
        tempUuid: tempUuid,
        msg: {
          history_id,
          place_id,
          message,
          tempUuid: tempUuid,
          isDraft: true,
          uuid: tempUuid,
          status: MessageStatus.SENDING,
          created: moment(),
          sender: getSelfSenderData(),
        },
      },
    })

    socket.emit(
      SocketEvent.ADMIN_SEND,
      history_id,
      place_id,
      message,
      (uuid, sentTime) => {
        dispatch({
          type: ActionType.SEND_MESSAGE_SUCCESS,
          payload: {
            tempUuid,
            uuid,
            sentTime,
          },
        })
      },
    )

    cb()

    setTimeout((e) => {
      dispatch({
        type: ActionType.CHECK_MESSAGE_TIMEOUT,
        payload: {
          tempUuid,
        },
      })
    }, SEND_MESSAGE_TIMEOUT)
  }

  const refetchConversationRoom = () => {
    dispatch({ type: ActionType.REFETCH })
  }

  const resendMessage = (tempUuid) => {
    if (socket.disconnected) {
      socket.connect()
    }

    if (sendingMessage[tempUuid]) {
      dispatch({
        type: ActionType.RESEND_MESSAGE,
        payload: {
          tempUuid: tempUuid,
        },
      }) //this going to remove failed status from  sending message list

      let message = sendingMessage[tempUuid]

      socket.emit(
        SocketEvent.ADMIN_SEND,
        message.history_id,
        message.place_id,
        message.message,
        (uuid, sentTime) => {
          dispatch({
            type: ActionType.SEND_MESSAGE_SUCCESS,
            payload: {
              tempUuid,
              uuid,
              sentTime,
            },
          })
        },
      )

      setTimeout((e) => {
        dispatch({
          type: ActionType.CHECK_MESSAGE_TIMEOUT,
          payload: {
            tempUuid,
          },
        })
      }, SEND_MESSAGE_TIMEOUT)
    }
  }

  const translateMessage = (uuid, fromLanguageCode, toLanguageCode, text) => {
    dispatch({
      type: ActionType.TRANSLATING_MESSAGE,
      payload: {
        uuid,
      },
    })

    socket.emit(
      SocketEvent.ADMIN_TRANSLATE,
      uuid,
      text,
      fromLanguageCode,
      toLanguageCode,
      (callback) => {
        if (callback.status === 'success') {
          dispatch({
            type: ActionType.TRALSATE_SUCCESS,
            payload: {
              uuid: callback.uuid,
              translatedMessage: callback.translatedMessage,
            },
          })
          return
        }
        if (callback.status === 'failed') {
          dispatch({
            type: ActionType.TRALSATE_FAILURE,
            payload: {
              uuid: callback.uuid,
              failureMessage: callback.failureMessage,
            },
          })
          return
        }
      },
    )
  }

  const deleteMessage = (tempUuid) => {
    dispatch({ type: ActionType.DELETE_MESSAGE, payload: { tempUuid } })
  }

  const showOriginalMessage = (uuid, isShow) => {
    dispatch({
      type: ActionType.SHOW_ORIGINAL_MESSAGE,
      payload: { uuid, isShow },
    })
  }

  const modifiedResData = (res) => {
    const newData = R.map(
      (obj) =>
        R.assoc('showOriginalMessage', obj.translatedMessage === null, obj),
      res.data,
    )
    res.data = newData
    return res
  }

  const refresh = () => {
    if (R.compose(R.not, R.isNil)(selectedConversation)) {
      if (R.isNil(selectedConversation.historyId)) {
        dispatch({
          type: ActionType.FETCH_SUCCESS,
          payload: modifiedResData({
            data: [],
            meta: { last_key: null, per_page: 20, total: 0 },
          }),
        })
        return
      }
      effects.apis
        .getConversationHistory(
          token.accessToken,
          selectedConversation.historyId,
        )
        .then((res) => {
          dispatch({
            type: ActionType.FETCH_SUCCESS,
            payload: modifiedResData(res),
          })

          if (res.data.length > 0) {
            const lastMessage = R.view(
              R.lensPath(['data', res.data.length - 1]),
              res,
            )
            if (lastMessage.role === 'user') {
              socket.emit(SocketEvent.ADMIN_READ, lastMessage.uuid)
            }
          }
          socket.off(SocketEvent.ADMIN_READ)
          socket.on(SocketEvent.ADMIN_READ, (data) => {
            dispatch({
              type: ActionType.USER_READ_MESSAGE,
              payload: {
                uuid: data.uuid,
                updated: data.updated,
              },
            })
          })
          socket.off(SocketEvent.ADMIN_ALLOW_TRANSLATION)
          socket.on(SocketEvent.ADMIN_ALLOW_TRANSLATION, (data) => {
            dispatch({
              type: ActionType.ALLOW_TRANSLATION,
              payload: {
                uuid: data.uuid,
                languageCode: data.languageCode,
                isAllowed: data.isAllowed,
              },
            })
          })
        })
        .catch((error) => {
          if (error.response) {
            dispatch({
              type: ActionType.FETCH_FAILURE,
              payload: error.response,
            })
          } else {
            dispatch({
              type: ActionType.FETCH_FAILURE,
              payload: 'error',
            })
          }
        })

      dispatch({
        type: ActionType.OPEN_CHAT_ROOM,
        payload: selectedConversation.historyId,
      })
    }
  }

  useEffect(() => {
    dispatch({ type: ActionType.FETCH_INIT })
    refresh()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedConversation, fetchedAt]) //init when change conversation

  useEffect(() => {
    storeDispatcher(setIsInConversationRoom(true))
    dispatch({ type: ActionType.FETCH_INIT_SOCKET })
    if (socket) {
      socket.off(SocketEvent.ADMIN_MESSAGE)
      socket.on(SocketEvent.ADMIN_MESSAGE, (msgData) => {
        updateConversationFromSocket(msgData)
        if (
          chatRoomData.data.length !== 0 &&
          selectedConversation.historyId === msgData.history_id
        ) {
          msgData.showOriginalMessage = msgData.translatedMessage == null
          var newData = {
            ...chatRoomData,
            data: chatRoomData.data.concat(msgData),
          }
          dispatch({ type: ActionType.FETCH_SUCCESS, payload: newData })
          if (userData.id !== msgData.sender.id) {
            socket.emit(SocketEvent.ADMIN_READ, msgData.uuid)
          }
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chatRoomData, conversationListData])

  const updateConversationFromSocket = (messageData) => {
    const filterData = R.compose(
      R.head,
      R.filter(R.propEq('historyId', R.prop('history_id', messageData))),
    )(conversationListData)

    if (filterData) {
      const dataSplit = R.filter(
        (item) => item.historyId !== R.prop('history_id', messageData),
        conversationListData,
      )
      const isAdmin = (messageData) => {
        if (historyIdSelected === R.prop('history_id', messageData)) {
          return true
        }
        return R.path('role', messageData) === ROLE_ADMIN
      }

      const newData = R.compose(
        R.set(
          R.lensPath(['dataLastMessage', 'lastMessage', 'uuid']),
          R.prop('uuid', messageData),
        ),
        R.set(
          R.lensPath(['dataLastMessage', 'lastMessage', 'historyId']),
          R.prop('history_id', messageData),
        ),
        R.set(
          R.lensPath(['dataLastMessage', 'lastMessage', 'message']),
          R.prop('message', messageData),
        ),
        R.set(
          R.lensPath(['dataLastMessage', 'lastMessage', 'created']),
          R.prop('created', messageData),
        ),
        R.set(
          R.lensPath(['dataLastMessage', 'lastMessage', 'is_read']),
          isAdmin(messageData),
        ),
        R.set(R.lensProp('isRead'), isAdmin(messageData)),
        R.set(
          R.lensPath(['dataLastMessage', 'person']),
          R.prop('sender', messageData),
        ),
      )(filterData)

      const newList = [newData, ...dataSplit]
      storeDispatcher(updateConversationList(newList))
    } else {
      effects.apis
        .getConversationDetail(R.prop('history_id', messageData))
        .then((respData) => {
          const newData = mapDataConversationList([respData])
          const newList = [...newData, ...conversationListData]
          storeDispatcher(updateConversationList(newList))
        })
    }
  }

  const mergeChatData = () => {
    return {
      ...chatRoomData,
      data: chatRoomData.data.concat(
        R.values(
          R.filter(
            R.propEq('history_id', R.prop('historyId', selectedConversation)),
            sendingMessage,
          ),
        ),
      ),
    }
  }

  const makeArchive = () => {
    let params = {
      historyId: selectedConversation.historyId,
    }
    return effects.apis.conversationsArchive(params)
  }

  const makeDelete = () => {
    let params = {
      historyId: selectedConversation.historyId,
    }
    return effects.apis.conversationsDelete(params)
  }

  return {
    chatRoomData: mergeChatData(),
    isConnected,
    socket,
    handleRecordUpdates,
    handleSendMessage,
    isChatLoading,
    fetchErrorChat: error,
    dispatchConversationSocket: dispatch,
    refetchConversationRoom,
    loadMoreMessage,
    lastKey,
    isLoadingMore,
    resendMessage,
    deleteMessage,
    translateMessage,
    makeArchive,
    makeDelete,
    showOriginalMessage,
  }
}
